import React from 'react';
import { SelectGroupButtons } from './radio-group-buttons';
import { FormLabel } from '../../form-label';
export const ButtonsSelectGroup = ({ items, selected, onSelect, required, label, labelTooltip }) => {
    return (React.createElement(React.Fragment, null,
        label && (React.createElement(FormLabel, { labelTooltip: labelTooltip, required: required }, label)),
        React.createElement(SelectGroupButtons, { items: items, selected: selected, onSelect: onSelect })));
};
